// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonCol, IonRow, IonText } from "@ionic/react"
import { useLocales } from "react-localized"
import ReactMarkdown from 'react-markdown'
import { LandingPageGrid, LandingPageHeading, LoginButton } from "../../../lib"
import logo from '../../../logo.svg'


const LoginComponent: React.FC = () => {
  const {gettext} = useLocales()
  return (
    <LandingPageGrid>
      <IonRow className="main section-padding-x">
        <IonCol>
          <LandingPageHeading
            logo={logo}
            title={gettext("Welcome")}
          />
          <IonText className="bold-primary">
            <ReactMarkdown>
              {gettext("You're not signed in with the Molano Console. Click the **Sign in to the Molano Console** button below to sign in with a verified email address.")}
            </ReactMarkdown>
            <ReactMarkdown>
              {gettext("If you don't have an account yet, you will be prompted to create one after signing in.")}
            </ReactMarkdown>
          </IonText>
        </IonCol>
      </IonRow>
      <IonRow className="main" style={{marginTop: "22px"}}>
        <IonCol style={{alignItems: "center", display: "flex"}}>
          <LoginButton style={{margin: "0 auto"}}>
            {gettext("Sign in to the Molano Console")}
          </LoginButton>
        </IonCol>
      </IonRow>
      <IonRow style={{paddingTop: "99px"}}>
        <img style={{width: "100%"}} src="https://cdn.shopify.com/s/files/1/0591/8425/1035/files/banner-molano_1600x.png?v=1647513239"/>
      </IonRow>
    </LandingPageGrid>
  )
}


export { LoginComponent }